import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import { Router } from '@angular/router'
import { finalize } from 'rxjs/operators'

import { ResultCode } from '../../../domain/authentication.model'
import { AuthService } from '../../../services/auth.service'
import { NotificationService } from '../../../services/notification.service'
import { I18nService, LgType } from '../../../services/prod/i18n.service'

@Component({
  selector: 'bmcore-update-email-form',
  templateUrl: './bmcore-update-email-form.component.html',
  styleUrls: ['./bmcore-update-email-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreUpdateEmailFormComponent implements OnInit {
  lg: LgType
  updateEmailForm: UntypedFormGroup
  isLoader = false

  constructor(
    private authService: AuthService,
    private notificationService: NotificationService,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private i18nService: I18nService
  ) {}

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()

    this.updateEmailForm = this.formBuilder.group({
      email: [],
      password: []
    })
  }

  onSubmit() {
    if (this.updateEmailForm.valid) {
      this.isLoader = true

      const { email, password } = this.updateEmailForm.value

      this.authService
        .changeEmailAddress(email.email, password.password)
        .pipe(finalize(() => (this.isLoader = false)))
        .subscribe(
          res => {
            if (res.resultCode === ResultCode.Success) {
              // 1. Logout user
              this.authService.isAuthenticated = false // need because of LoginGuard
              this.authService.logout()

              // 2. Redirect to check-email page
              this.router.navigate(['/check-email', { email: email.email, path: 'signUp' }])
            } else {
              this.notificationService.handleError(res.messages[0])
            }
          },
          err => this.notificationService.handleError(err.message)
        )
    } else {
      this.notificationService.handleError(this.lg.forms.error)
    }
  }
}
